import { useCallback } from "react";
import { SearchDialogStatesType } from "../states/dialogs";
import { SearchIsochroneStatesType } from "../states/isochrones";

export const useSearchIsochroneDialogHandlers = (
  dialogStates: SearchDialogStatesType,
  isochroneStates: SearchIsochroneStatesType
) => {
  const onIsochroneDialogClose = useCallback(() => {
    dialogStates.setShowIsochroneDialog(false);
  }, [dialogStates]);

  const onIsochroneDialogMouseDown = useCallback(() => {}, []);

  const onOkButtonClick = useCallback(
    (walking: boolean, cycling: boolean, driving: boolean, minutes: number) => {
      if (
        dialogStates.isochroneCenterLat === undefined ||
        dialogStates.isochroneCenterLng === undefined
      ) {
        return;
      }

      isochroneStates.addIsochrone({
        lat: dialogStates.isochroneCenterLat,
        lng: dialogStates.isochroneCenterLng,
        walking,
        cycling,
        driving,
        minutes
      });
    },
    [
      dialogStates.isochroneCenterLat,
      dialogStates.isochroneCenterLng,
      isochroneStates
    ]
  );

  return {
    onIsochroneDialogClose,
    onIsochroneDialogMouseDown,

    onOkButtonClick
  } as const;
};

export type SearchIsochroneDialogHandlersType = ReturnType<
  typeof useSearchIsochroneDialogHandlers
>;
